import {useCallback, useContext} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import {useAnalyticsTrack} from '@adv-mt/mt-tracking-use-analytics'
import {Tabs} from '@adv-mt/ui/tabs'

import {scrollToSection} from '../../utils.js'
import {BASE_CLASS} from './config.js'

const getSectionNavI18nKey = id => `DETAIL.SECONDARY_BAR.NAV.${id.toUpperCase()}`

const SectionNav = ({activeSectionId, visibleSectionIds}) => {
  const {domain, i18n} = useContext(Context)
  const {track} = useAnalyticsTrack()

  const {TRACKING_EVENT_NAMES} = domain.get('config').get('tracking')
  const {AD_DETAIL_PAGE_SECTION_TRACKING_HIT_INFORMATIONS: hitInformationsBySectionId} = domain
    .get('config')
    .get('COMMON').AD_DETAIL_PAGE_SECTIONS

  const handleValueChange = useCallback(
    id => {
      scrollToSection(id)

      track({
        event: TRACKING_EVENT_NAMES.DETAIL_NAVBAR_CLICKED,
        data: {hit_information: hitInformationsBySectionId[id]}
      })
    },
    [TRACKING_EVENT_NAMES, hitInformationsBySectionId, track]
  )

  if (!visibleSectionIds.length) return null

  // null deselects every tab — the scroll spy returns it below the last section,
  // where the content on screen belongs to no tab.
  const activeValue = visibleSectionIds.includes(activeSectionId) ? activeSectionId : null

  return (
    <nav className={`${BASE_CLASS}-sectionNav`}>
      <Tabs.Root value={activeValue} onValueChange={handleValueChange}>
        <Tabs.List>
          {visibleSectionIds.map(id => (
            <Tabs.Tab key={id} value={id}>
              {i18n.t(getSectionNavI18nKey(id))}
            </Tabs.Tab>
          ))}
        </Tabs.List>
      </Tabs.Root>
    </nav>
  )
}

SectionNav.displayName = 'SectionNav'
SectionNav.propTypes = {
  activeSectionId: PropTypes.string,
  visibleSectionIds: PropTypes.arrayOf(PropTypes.string).isRequired
}

export default SectionNav
